<template>
    <div class="vertical-item text-center">
        <div class="title p-1 text-white text-uppercase" :class="isHighlight? 'bg-primary' : 'bg-secondary'">
            <span>{{label}}</span>
        </div>
        <div class="position-relative">
            <small-carousel :images="images" :show-indicators="false" height="160px"></small-carousel>
            <div class="circle-area" v-if="isOffertaSpeciale">
                <p>Offerta Speciale</p>
            </div>
        </div>
        <div class="content-area">
            <div>
                <p>{{name}}</p>
            </div>
            <h2 class="mb-3">{{date}}</h2>
            <div class="row" style="height: 50px">
                <div class="col-6">
                    <div v-if="nights" class="notti text-left mb-2">
                        <p>
                            <b>{{this.nights}}</b> notti<br><b>{{this.days}}</b> giorni
                        </p>
                    </div>
                </div>
                <div v-if="isAltreDate" class="dates-info col-6 mb-2">
                    <div class="dates position-relative" v-if="isAltreDate">
                        <a href="javascript:void(0)" class="dates text-uppercase" @click="showAltreDate = !showAltreDate">
                            altre date disponibili
                        </a>
                        <div v-if="showAltreDate" @mouseleave="showAltreDate = false" @click="showAltreDate = false"
                             class="position-absolute p-1 border rounded bg-white"
                             style="z-index: 10; min-width: 240px; max-height: 160px; overflow: auto; right: 0">
                            <button v-for="(item, index) in departureFutureDates" :key="index" @click="onOpenDetailWithDate(item)" style="width: 45px"
                                    class="rounded-0 m-1 px-1 btn btn-outline-primary btn-sm nowrap">{{formatDate(item)}}</button>
                        </div>
                    </div>
                </div>
                <div v-if="isPartenzaGarantita" class="col-6 mb-2">
                    <div class="partenza-garantita text-left">
                        <p>partenza garantita</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="price">
            <div>
                <span>a partire da</span>
            </div>
            <div class="d-flex justify-content-between">
                <div>
                    <h1 class="currency mb-0">{{price}} &euro;</h1>
                    <h5 class="w-100 text-center text-uppercase mb-1">{{isVoloRequested? 'volo incluso' : '&nbsp;'}}</h5>
                </div>
                <div class="mb-3">
                    <button class="btn btn-primary btn-lg px-5" @click="onOpenDetail">Scegli</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import VerticalItemTourDesktop from '../../../../widgets/common/tours/VerticalItemTour'

export default {
  name: 'VerticalItemTour',
  mixins: [VerticalItemTourDesktop]
}
</script>



// WEBPACK FOOTER //
// src/front/components/mobile/widgets/common/tours/VerticalItemTour.vue